import { formatToTimeZone } from "date-fns-timezone";
import { is } from "ramda";
import { isBefore, format } from "date-fns";

const DEFAULT_DATE_FORMAT = "MM/dd/yyyy";
const DEFAULT_FORMAT_OPTIONS = {
  timeZone: "UTC",
  convertTimeZone: false,
};

const formatDateForAPI = (date) => format(date, "yyyy-MM-dd");

const formatDate = (
  date,
  _format = DEFAULT_DATE_FORMAT,
  formatOptions = DEFAULT_FORMAT_OPTIONS
) => formatToTimeZone(date, _format, formatOptions);

/**
 * Returns `date` as a string format and converted to America/Chicago
 * which almost all the time is in Central timezone.
 * See this [https://en.wikipedia.org/wiki/List_of_tz_database_time_zones#CHICAGO]()
 * @returns {string} Date in format `YYYY-MM-DDTHH:mm:ss`
 */
export const convertToCentral = (date) => {
  const newDate = formatToTimeZone(date, "yyyy-MM-ddTHH:mm:ss", {
    timeZone: "America/Chicago",
    convertTimeZone: true,
  });
  return newDate;
};

const parseDateToUTC = (date) => {
  const dateToFormat = is(Date, date) ? date.toISOString() : date;

  return Date.UTC(
    dateToFormat.substring(0, 4),
    dateToFormat.substring(5, 7) - 1,
    dateToFormat.substring(8, 10)
  );
};

const newDateStringUTC = () => {
  const date = new Date();

  return date.toISOString();
};

const newDayEndOfDay = (_date = new Date()) => {
  const date = new Date(_date);
  date.setHours(23, 59, 59);

  return date;
};

const newDayBeginOfDay = (_date = new Date()) => {
  const date = new Date(_date);
  date.setHours(0, 0, 0);

  return date;
};

const addCurrentTimeToDate = (date) => {
  const currentDate = new Date();

  date.setHours(
    currentDate.getHours(),
    currentDate.getMinutes(),
    currentDate.getSeconds()
  );

  return date;
};
const mergeDateAndTime = (date, datetime) => {
  const _date = new Date(date);
  const _time = new Date(datetime);

  _date.setHours(_time.getHours(), _time.getMinutes(), _time.getSeconds());

  return _date;
};

const isBeforeToday = (date) => isBefore(date, new Date());

export {
  addCurrentTimeToDate,
  newDayBeginOfDay,
  newDateStringUTC,
  formatDateForAPI,
  mergeDateAndTime,
  newDayEndOfDay,
  parseDateToUTC,
  isBeforeToday,
  formatDate,
  DEFAULT_DATE_FORMAT,
};
